import Swal from 'sweetalert2';
import * as actionTypes from '../actionTypes';
import { put, call, takeLeading } from 'redux-saga/effects';
import { getAPI, postAPI, patchAPI } from '../../utils/api-function';
import { create_flight_images, get_flight_images, update_flight_images } from '../../utils/api-routes';

function* getFlightImages() {
    try {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: true });
        const { data } = yield getAPI(get_flight_images);
        console.log("Get Flight Images Saga Response ::: ", data);

        if (data?.success) {
            yield put({ type: actionTypes.SET_FLIGHT_IMAGES, payload: data?.data });
            yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
        }

    } catch (error) {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
        console.log("Get Flight Images Saga Error ::: ", error);
    }
}

function* createFlightImages(action) {
    try {
        const { payload } = action;
        console.log("createFlightImages Payload ::: ", payload);

        const { data } = yield postAPI(create_flight_images, payload?.data);
        console.log("Create Flight Image Saga Response ::: ", data);

        if (data?.success) {
            Swal.fire({ icon: "success", title: 'Success', text: "Created Successfully", showConfirmButton: false, timer: 2000, });
            yield put({ type: actionTypes.GET_FLIGHT_IMAGES, payload: null });
            yield call(payload?.onComplete);
        }

    } catch (error) {
        Swal.fire({ icon: "error", title: 'Failed', text: "Failed To Create", showConfirmButton: false, timer: 2000 });
        console.log("Create Flight Image Saga Error ::: ", error);
    }
}

function* updateFlightImages(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        const { data } = yield patchAPI(update_flight_images, payload?.data);
        console.log("Update Flight Image Saga Response ::: ", data);

        if (data?.success) {
            Swal.fire({ icon: "success", title: 'Success', text: "Updated Successfully", showConfirmButton: false, timer: 2000, });
            yield put({ type: actionTypes.GET_FLIGHT_IMAGES, payload: null });
            yield call(payload?.onComplete);
        }

    } catch (error) {
        Swal.fire({ icon: "error", title: 'Failed', text: "Failed To Update", showConfirmButton: false, timer: 2000 });
        console.log("Update Flight Image Saga Error ::: ", error);
    }
}

export default function* FlightImageSaga() {
    yield takeLeading(actionTypes?.GET_FLIGHT_IMAGES, getFlightImages);
    yield takeLeading(actionTypes?.CREATE_FLIGHT_IMAGES, createFlightImages);
    yield takeLeading(actionTypes?.UPDATE_FLIGHT_IMAGES, updateFlightImages);
};